import { Controller, Path, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CustomerSearchFilters } from "../../../types";
import { InputBaseComponentProps, TextField } from "@mui/material/index";

interface CBSearchTextFieldControllerProps {
    idField: string,
    formName: Path<CustomerSearchFilters>,
    label: string,
    inputProps?: InputBaseComponentProps
}

const CBSearchTextFieldController = ({
    idField,
    formName,
    label,
    inputProps

}: CBSearchTextFieldControllerProps) => {

    const { t } = useTranslation('customerbase');
    const formContext = useFormContext<CustomerSearchFilters>();

    return (
        <Controller
            control={formContext.control}
            name={formName}
            render={({field, fieldState}) => ( 
                <TextField 
                    fullWidth
                    autoComplete="off"
                    inputProps={inputProps}
                    id={idField}
                    type="text"
                    label={t(label)}
                    value={field.value ? field.value : ""}
                    onChange={(value) => {
                        field.onChange(value);
                    }}
                    error={Boolean(fieldState.error)}
                    helperText={fieldState.error?.message}
                />
            )}
        />
    )

}

export default CBSearchTextFieldController;